import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileCard from '../components/ProfileCard';
import blueImage from '../images/blue.png';
import greyImage from '../images/grey.png';
import redImage from '../images/red.png';
import yellowImage from '../images/yellow.png';
import './browse.css';

const Browse: React.FC = () => {
  const navigate = useNavigate();

  const profiles = [
    {
      name: "recruiter",
      image: blueImage,
      backgroundGif: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExMWRtOGoyNzZtMnBrZmxrOXJzdDEzNjJ6Ymc0NXl4a3p1a3Z1dW9yZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l2R098V90nJfuHKg0/giphy.gif" // Dark storm clouds
    },
    {
      name: "developer",
      image: greyImage,
      backgroundGif: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExYXN5dXZ3cTRxajFybHlmbWt1ZWY1azdoOWwwOXMxOHRlc2VwcGh4ZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/4OV1bLOIWwIXRxpXlN/giphy.gif" // Flickering neon lights
    },
    {
      name: "stalker",
      image: redImage,
      backgroundGif: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZTlpeGxma3A4M3Q5NXZsZGtra2tuMW1leDJneThiOTRicmxtd2hleCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3oeHLtOWbFhO4r0ToA/giphy.gif" // Dark, abstract digital lights
    },
    {
      name: "adventurer",
      image: yellowImage,
      backgroundGif: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExbGxya2Y0Z3o0dWd6aHVuaHZlbmlqNWk4bXM0a2NnZzNnOWFxZmRucCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/IsNuZjQnM6z04/giphy.gif" // Dark ocean waves at night
    },
  ];

  const handleProfileClick = (profile: { name: string; image: string; backgroundGif: string }) => {
    navigate(`/profile/${profile.name}`, { state: { profileImage: profile.image, backgroundGif: profile.backgroundGif } });
  };

  return (
    <div className="browse-container">
      <p className='who-is-watching'>Who's Watching?</p>
      <div className="profiles">
        {profiles.map((profile, index) => (
          <ProfileCard
            key={index}
            name={profile.name}
            image={profile.image}
            onClick={() => handleProfileClick(profile)}
          />
        ))}
      </div>
    </div>
  );
};

export default Browse;
